/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Button } from '@tishman/components';
import React from 'react';

import { actions, useAppDispatch } from '../../store';
import { newRelic } from '../../utils/new-relic';

import type { ThemeUIStyleObject } from 'theme-ui';
import type { SyntheticEvent } from 'react';

interface ContinueButtonProps {
  className?: string;
  disabled?: boolean;
  onClick?: (e: SyntheticEvent) => void | Promise<void>;
  sx?: ThemeUIStyleObject;
  title?: string;
  tabIndex?: HTMLButtonElement['tabIndex'];
}

/** Continue Button advances from current step to next step.
 * It is only active once canContinue is set to true from
 * a step component.
 */
export const ContinueButton = ({
  className,
  disabled,
  onClick,
  sx,
  title,
  tabIndex,
}: ContinueButtonProps): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const continueClickHandler = (e: SyntheticEvent) => {
    if (onClick !== undefined) {
      onClick(e);
    } else {
      newRelic.logCartAction('ContinueButton', 'setNextStep');
      dispatch(actions.wizard.setNextStep());
    }
  };
  return (
    <Button
      aria-label={title ?? 'continue'}
      className={className}
      data-gtm-trigger="continue"
      data-testid="continue-button-component"
      disabled={disabled}
      onClick={continueClickHandler}
      sx={{ ...sx }}
      tabIndex={tabIndex}
      variant="inverted"
    >
      {title ?? 'continue'}
    </Button>
  );
};
